// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const ThermometerContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  /* ******* LARGE DESKTOP (LG - 992px and up) ******* */
  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1.25rem;
  };

  /* ******* EXTRA LARGE DESKTOP (XL - 1200px and up) ******* */
  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 0;
  };
`;

export const CavityLevelModuleContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  flex-direction: column;
  display: flex;
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  width: 100%;
  height: 100%;
`;

export const TitleContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  width: 100%;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;
